export const actions = {
  async updateAwb({ commit }, { orderId, awb }) {
    try {
      await this.$axios.$patch(`admin/orders/${orderId}`, { awb })

      this.$toast.success('AWB salvat!')
    } catch (error) {
      this.$toast.error('Eroare la salvare AWB.'.error)
      console.error(error)
    }
  },
  async updateCourier({ commit }, { orderId, courier }) {
    try {
      await this.$axios.get(`admin/orders/changeCourier/${orderId}/${courier}`)
      // await this.$axios.$put(`/orders/${orderId}/courier`, { courier })
      this.$toast.success('Curier salvat!')
    } catch (error) {
      this.$toast.error('Eroare la salvare!')
      console.error(error)
    }
  },
  async updateClientOrderId({ commit }, { orderId, clientOrderId }) {
    try {
      await this.$axios.$patch(`admin/orders/${orderId}`, { client_order_id: clientOrderId })
      this.$toast.success('Client Order ID salvat!')
    } catch (error) {
      this.$toast.error('Eroare la salvare Client Order ID.')
      console.error(error)
    }
  },
}
